import Vue from "vue";
import App from "./App.vue";
import setupRouter from "./core/setup/routerSetup";
import setupUse from "./core/setup/setupUse";
import setupComponent from "./core/setup/setupComponent";
import vuetify from "./core/plugins/vuetify";

//js
import "@/assets/js/main"

//css
import "sweetalert2/dist/sweetalert2.min.css";
import "vue2-datepicker/index.css";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import "@mdi/font/css/materialdesignicons.css";

import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import ClipboardJS from "clipboard";
import PerfectScrollbar from "perfect-scrollbar";
import setupAxios from "./core/setup/setupAxios";

Vue.config.productionTip = false;

window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;

ApiService.init();

const router = setupRouter();
setupUse(Vue);
setupComponent(Vue);
setupAxios();

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
